import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const equityOffering: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'offerType' },
            { type: 'field', field: 'offerPrice' },
            { type: 'field', field: 'offerCurrency' },
            { type: 'field', field: 'exDate' },
        ],
    },
    {
        controls: [
            { type: 'field', field: 'exDate' },
            { type: 'field', field: 'shareOffer' },
            { type: 'field', field: 'amountOffer' },
        ],
    },
];

export default equityOffering;
